import { isHdl } from "@haidilao-private/jsbridge";

/**
 * @description: 计算像素
 * @param {number} num
 * @return {*}
 */
export const $vw = (num: number) => (num / 390) * 100 + "vw";

/**
 * @description:判断环境
 * env ： app   mini小程序    wx
 */
export function isEnv() {
	if (isHdl) {
		return "App";
	}
	// return 'H5';
	return "App";
}

// 端外 设置导航栏标题（微信）
export const setDocumentTitle = (title: string) => {
	try {
		const document = window.document;
		document.title = title;
	} catch (err) {
		console.log(err);
	}
};

/**
 * 跳转优惠券,app4.0.0及以上版本可用
 */
export const navigateToCoupon = () => {
	try {
		flutter_inappwebview?.callHandler("navigateToCoupon");
	} catch (error) {
		console.error(error);
	}
};

// 检查是否在app中
export const isInApp = () => {
	const userAgent = navigator.userAgent;
	if (userAgent.includes("Haidilao")) {
		return true;
	} else {
		return false;
	}
};


/**
 * 判断是否为line环境
 * @returns
 */
export const isLine = () => {
  const _ua = navigator.userAgent;
  const _isLine = /Line/i.test(_ua);
  return _isLine;
};